export const GEMINI_PROMPT = `
    Given the following PDF, please find all the tables and extract the data into the following JSON format:
    [
        {
            "door": 1,
            "shelves": [
            {
                "shelf": 1,
                "products": [
                {
                    "upc": "4900005374",
                    "name": "Fanta Orange 1/16oz can",
                    "facingQuantity": 1
                },
                {
                    "upc": "4900005343",
                    "name": "Sprite 1/16oz",
                    "facingQuantity": 2
                },
                ...
                ]
            },
            ...
            ]
        },
        ...
    ]
`

export const JSON_SCHEMA = `
[
    {
        "door": number,
        "shelves": [
        {
            "shelf": number,
            "products": [
            {
                "upc": string,
                "name": string,
                "facingQuantity": number
            },
            ...
            ]
        },
        ...
        ]
        ...
    }
]
`
